// ProjectLayout — the project "domain" frame (operational pages: home +
// monitoring / sites / assets / tickets / reports).
//
// Thin by design (the reconcile decision): the top bar is single-sourced in
// AuthedLayout's Navbar and the <main> landmark is owned by AuthedLayout, so
// this frame renders only the content canvas + reserves the polymorphic left
// region. The left region (the faceted filter panel for operational domains) is
// RESERVED here and lands at the first filter page; today the page owns
// the full canvas.
//
// Symmetric counterpart to the pathless AdminLayout — both are pathless layout
// routes that partition /p/:projectId by which left region the page needs.

import { Outlet } from 'react-router-dom';
import { useProjectParams } from '../../hooks/useProjectParams.js';
import { PeekHost } from './PeekHost.js';
import { pageBox, pageGutter } from './pageBox.js';

export function ProjectLayout() {
  const projectId = useProjectParams();
  return (
    <div className={`${pageBox} flex-1 ${pageGutter} py-6`}>
      <Outlet />
      {/* Global entity-peek host (ADR-036 §2) — same host as the admin frame, so
          a domain page (sites) opens a peek by writing ?peek=type:id, never by
          rendering a peek component itself (the peek-host harmonization). */}
      <PeekHost projectId={projectId} />
    </div>
  );
}
